export enum EExeItemType {
  Render,
  NewPage,
}

export interface ExeItem {
  type: EExeItemType;
  item: string;
  size: number;
  selEq: string[];
  selAbc: string[];
  text: string;
  archiveMap?: Record<string, { archive: string; file: string }>;
}

export interface ExeOptions {
  colorSchema: string;
  margin: number;
  renderResults: boolean;
}

export interface ExeProject {
  options: ExeOptions;
  items: ExeItem[];
}

export class ExeResults {
  public exercises = new Map<string, { key: string; value: string }[]>();

  public add(exercise: string, key: string, value: string): void {
    if (!this.exercises.has(exercise)) {
      this.exercises.set(exercise, []);
    }
    this.exercises.get(exercise)!.push({ key, value });
  }
}

export function createDefaultExeOptions(): ExeOptions {
  return { colorSchema: 'Black', margin: 20, renderResults: false };
}

export function createDefaultExeItem(item: string): ExeItem {
  return { type: EExeItemType.Render, item, size: 50, selEq: [], selAbc: [], text: '' };
}

export function createNewPageItem(): ExeItem {
  return { type: EExeItemType.NewPage, item: '', size: 0, selEq: [], selAbc: [], text: '' };
}
